class Data {
    constructor(onComplete, onError) {
        const creator = new URLSearchParams(window.location.search).get("creator") || "KT1HbQepzV1nVGg8QVznG7z4RcHseD5kwqBn";
        const viewer = new URLSearchParams(window.location.search).get("viewer") || "tz1hM6Pz2e5vJbd1YYkYHcj5RL7tXhcn59Xr"
        const objkt = new URLSearchParams(window.location.search).get("objkt") || '428870';
        console.log("NFT created by", creator); // null if local
        console.log("NFT viewed by", viewer); // null if local
        console.log("OBJKT ID is", objkt); // null if local
       // let viewerWasFound = viewerData && !viewerData.includes("false");
        const objktID = objkt;
        this.fetchData(objktID)
        .then((data) => {
            //Take all users and return array of indexes that are owned by viewer.
            const idsOwnedByUser = data.token_holders.reduce((prev, curr, currentIndex) => {
                if(curr.holder.address === viewer) {
                    return prev.concat([currentIndex]);
                }
                else {
                    return prev
                }
            }, []);

            const names = data.token_holders.map(token => token.holder.name || token.holder.address.slice(0, 6));

            onComplete({
                supply: data.supply,
                purchased: data.token_holders.length,
                idsOwnedByUser,
                names
            });
        })
        .catch((error)=> {
            console.log(error);
            onError();
        })
    }

    async fetchGraphQL(operationsDoc, operationName, variables) {
        const result = await fetch("https://api.hicdex.com/v1/graphql", {
            method: "POST",
            body: JSON.stringify({
                query: operationsDoc,
                variables: variables,
                operationName: operationName,
            }),
        });
        return await result.json();
    }

    async fetchData(objktId) {
        const { errors, data } = await this.fetchGraphQL(query, "Objkt", { id: objktId });
        if (errors) {
            console.error(errors);
        }
        const result = data.hic_et_nunc_token_by_pk;
        console.log({ result });
        return result;
    }    
}

const query = `
  query Objkt($id: bigint!) {
    hic_et_nunc_token_by_pk(id: $id) {
      artifact_uri
      creator {
        address
        name
      }
      description
      display_uri
      id
      level
      mime
      royalties
      supply
      token_holders(where: {quantity: {_gt: "0"}}, order_by: {id: asc}) {
        quantity
        holder {
          address
          name
        }
      }
      hdao_balance
      extra
    }
  }
`;

export default Data;